import script from "./ReportBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportBuilder.vue?vue&type=script&setup=true&lang=js"

import "./ReportBuilder.vue?vue&type=style&index=0&id=7923ece3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7923ece3"]])

export default __exports__